<template lang="html">
  <b-navbar  id="navbar" toggleable="md" type="dark" fixed="top" variant="dark">
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-brand href="#">Energy Literacy</b-navbar-brand>
      <b-navbar-nav class="ml-auto flex-row justify-content-left align-items-center">
        <b-button-toolbar class="d-flex">
          <b-dropdown class="mx-1 d-inline-flex align-items-baseline" text="layout" left>
          <div class="nopad d-inline-flex">
            <b-list-group>
              <b-list-group-item href="#" class="d-inline-flex justify-content-center" @click="$store.dispatch('toggle_accum')">
                <em class="d-inline-flex nowrap">{{accum?"de":""}}accumulate errors</em>
              </b-list-group-item>
              <b-list-group-item href="#" class="d-inline-flex justify-content-center" @click="$store.dispatch('toggle_squash')">
                <em class="d-inline-flex nowrap">{{squash?"add":"remove"}} spacing</em>
              </b-list-group-item>
              <b-list-group-item href="#" class="d-inline-flex justify-content-center" @click="$store.dispatch('toggle_naics')">
                <em class="d-inline-flex nowrap">{{group_naics?"expand NAICS groups":"group by NAICS"}}</em>
              </b-list-group-item>
              <b-list-group-item href="#" class="d-inline-flex justify-content-center" @click="$store.dispatch('toggle_passthroughs')">
                <em class="d-inline-flex nowrap">{{make_passthroughs?"allow":"remove"}} crossovers</em>
              </b-list-group-item>
              <b-list-group-item href="#" class="d-inline-flex justify-content-center" @click="$store.dispatch('toggle_ghost_quads')">
                <em class="d-inline-flex nowrap">{{ghosts?"disable":"enable"}} ghost quads</em>
              </b-list-group-item>
            </b-list-group>
          </div>
          </b-dropdown>

          <b-button-group>
            <b-dropdown variant="light" text="groupings" left>
              <div class="scrollable check_group">
                <b-form-checkbox-group button-variant="light" buttons @input="set_selected_tags" stacked :options="tags">
                </b-form-checkbox-group>
              </div>
            </b-dropdown>
            <b-btn variant="success" v-on:click="regroup">regroup</b-btn>

          </b-button-group>

        </b-button-toolbar>

        <b-form inline class="ml-4 flex-nowrap">
          <b-input class="pr-0 d-inline-flex mb-2 mr-sm-2 mb-sm-0" type="text" placeholder="set search term..."  @input="set_search_term"/>
          <b-nav-text>Search</b-nav-text>
        </b-form>
        <b-form inline class="ml-4 flex-nowrap">
          <b-input class="tmp pr-0 mb-2 mr-sm-2 mb-sm-0" :value="resolution" type="number" step=".01"  @input="set_resolution"/>
          <b-nav-text>Resolution</b-nav-text>
        </b-form>

      </b-navbar-nav>

      <b-navbar-nav class="ml-auto flex-row justify-content-left align-items-center">

        <b-btn v-b-modal.csvloadModal> import csv... </b-btn>
        <b-dropdown class="mx-1 d-inline-flex align-items-baseline" text="export" right>
          <div class="nopad d-inline-flex">
            <b-list-group>
              <b-list-group-item href="#" @click="save_svg" class="d-inline-flex justify-content-center">
                <em class="d-inline-flex nowrap">download layout as svg</em>
              </b-list-group-item>
              <b-list-group-item href="#" @click="save_csv" class="d-inline-flex justify-content-center">
                <em class="d-inline-flex nowrap">download data as csv</em>
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-dropdown>

        <template v-if="authenticated">
        <b-btn :variant="save_variant" v-b-modal.saveModal> save... </b-btn>
        <b-dropdown class="mx-1 d-inline-flex align-items-baseline" text="load" right>
          <div class="scrollable d-inline-flex">
            <b-list-group>
              <template v-for="saved in $store.state.backend.saved_settings">
                <b-list-group-item href="#" @click="load(saved)" class="d-inline-flex" :key=saved.id>
                  <div class="d-inline-flex flex-column nowrap">
                    <b class="d-inline-flex nowrap">{{saved.title}}</b>
                    <em class="d-inline-flex nowrap">{{format_date(saved.time)}}</em>
                    <em class="d-inline-flex smaller">{{saved.notes}}</em>
                  </div>
                </b-list-group-item>
              </template>
            </b-list-group>
          </div>
        </b-dropdown>
        </template>
        <b-btn class="mx-1" v-if="!authenticated" v-on:click="$store.dispatch('login')"> sign in</b-btn>
        <b-btn class="mx-1" v-if="authenticated" v-on:click="$store.dispatch('logout')">sign out</b-btn>
      </b-navbar-nav>

    </b-collapse>

    <!-- SaveModal -->
    <b-modal @ok="save" centered header-bg-variant="warning" id="saveModal" title="Save as">
      <b> Title: </b>
      <b-form-input v-model="save_title" />
      <b> Notes: </b>
      <b-form-textarea id="textarea1"
                       v-model="save_text"
                       :rows="3"
                       :max-rows="6">
      </b-form-textarea>
    </b-modal>

    <!-- importModal -->
    <b-modal @ok="import_csv" centered header-bg-variant="warning" id="csvloadModal" title="Import CSV">
      <div class="mt-3">Nodes: {{node_file && node_file.name}}</div>
      <b-form-file accept=".csv" v-model="node_file" :state="Boolean(node_file)" placeholder="Upload nodes..." plain></b-form-file>
      <div class="mt-3">Links: {{links_file && links_file.name}}</div>
      <b-form-file accept=".csv" v-model="links_file" :state="Boolean(links_file)" placeholder="Upload links..." plain></b-form-file>
    </b-modal>
  </b-navbar>




</template>

<script>

import {mapState, mapGetters} from 'vuex'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

const json2csv = require('json2csv').parse;


import * as d3 from 'd3'

import '../../node_modules/bootstrap/dist/css/bootstrap.css'
import '../../node_modules/bootstrap-vue/dist/bootstrap-vue.css'


export default {
  data() {
    return {
      save_title:"",
      save_text:"",
      node_file:null,
      links_file:null
    }
  },
  mounted(){
    if(this.authenticated){
      this.$store.dispatch('load_info')
    }
  },
  computed:{
    ...mapState(['resolution','selected_tags','nodes','squash','accum','group_naics','make_passthroughs','ghosts']),
    authenticated(){
      return this.$store.state.backend.isAuthenticated
    },
    layout_btns(){
      return [(this.accum?"de":"")+"accumulate",
              (this.squash?"add":"remove")+" spacing"
             ]
    },
    export_options(){
      return ["download layout as svg",
              "download data as csv"
             ]
    },
    tags() {
      var out = {}
      Object.values(this.nodes).forEach( n=>{
        n.get_tags().forEach( k=>{
          out[k]=1
        })
      })
      return Object.keys(out)
    },
    save_variant(){
      return this.$store.state.dirty ? "warning" : ""
    },
  },
  methods: {
    load(saved){
      this.$store.dispatch("load",saved)
    },
    format_date(d){
      var s = d.split(' ')
      var yr = s[0]
      var time = s[1]
      return yr + ", " + time
    },
    import_csv(){
      if (!(this.node_file && this.links_file))
        return

      function csvJSON(csv){
        var lines=csv.split("\n")
        var result = []
        var headers=lines[0].split(",")
        for(var i=1;i<lines.length;i++){
	        var obj = {}
	        var currentline=lines[i].split(",")
	        for(var j=0;j<headers.length;j++){
		        obj[headers[j]] = currentline[j]
	        }
	        result.push(obj)
        }
        return result
      }
      var nf = new FileReader()
      nf.onload= ()=>{
        var lf = new FileReader()
        lf.readAsText(this.links_file)
        lf.onload= ()=>{
          this.$store.dispatch('load_base_data',{nodes:csvJSON(nf.result),links:csvJSON(lf.result)})
        }
      }
      nf.readAsText(this.node_file)
    },
    save(){
      this.$store.dispatch("save",{"title":this.save_title,"notes":this.save_text})
      this.save_title=""
      this.save_text=""
    },
    save_csv(){
      var data = this.$store.getters['raw_nodes']
      data = data.filter( n=>{ if (n.name.includes("*waste*") || n.name.includes("*energy")) return false; return true})
      var fields = ['name','id','tags','state_breakdown','waste_percentage','machine_type','coal_overhead','petroleum_overhead','natural_gas_overhead','nuclear_overhead','solar/pv_overhead','biomass_overhead','wind_overhead','hydroelectric_overhead','geothermal_overhead']
      var opts = {fields}
      var csv1 = json2csv(data,opts);

      data = Object.assign([],Object.values(this.$store.state.links))
      data = data.filter( l=>{ if (l.target.name.includes("*waste*") || l.target.name.includes("*energy")) return false; return true})
      data = data.map(l=>{ l.source_id=l.source.index
                           l.target_id=l.target.index
                           l.target_name=l.target.name
                           l.source_name=l.source.name
                           return l
                         })
      fields = ['source_name','target_name','value','source_id','target_id','reference']
      opts = { fields }
      var csv2 = json2csv(data,opts)
      var csvs = [csv1,csv2]
      csvs.forEach( (csv,id) =>{
        try{
          var pom = document.createElement('a')
          pom.setAttribute('href', 'data:application/octet-stream;charset=utf-8,' + encodeURIComponent(csv))
          pom.setAttribute('download', "sankey_" + (id==0?"nodes":"links") + ".csv")
          pom.click()
          pom.remove()
        } catch (err) {
          console.error("error!",err);
        }
      })

    },

    save_svg(){
      ['svg_nodes','svg_links'].forEach( (n)=>{
        var svg_xml=''
        var svg = document.getElementById(n)
        var ss = new XMLSerializer()
        svg_xml+=ss.serializeToString(svg)
        var pom = document.createElement('a')
        pom.setAttribute('href', 'data:application/octet-stream;charset=utf-8,' + encodeURIComponent(svg_xml))
        pom.setAttribute('download', "sankey_" + n + ".svg")
        pom.click()
        pom.remove()
      })
    },
    set_resolution(e){
      this.$store.commit('set_resolution',{getters:this.$store.getters,val:e})
      this.$store.commit("runInitialLayout",this.$store.getters)
    },
    set_search_term(e){
      this.$store.commit('set_search_term',e)
    },
    set_selected_tags(e){
      this.$store.commit('set_selected_tags',e)
    },
    regroup(){
      this.$store.dispatch('tag_accumulate')
    }
  }
};
</script>

<style scoped>

.dropdown >>> button {
    display:inline-flex;
    align-items:center;
}

//dropdown arrows
.dropdown >>> *::after {
    display:inline-flex !important;
}

.scrollable{
    height:auto;
    max-height:456px;
    overflow-y: auto;
}

.btn, .dropdown >>> .btn{
    height:27px !important;
    line-height: .5;
    padding-left:7px;
    padding-right:7px;
}

input{
    height:25px !important;
}

.navbar{
    height:45px !important;
}

.dropdown >>> div {
    padding-top:0px;
    padding-bottom:0px;
    min-width:0px !important;
}

.dropdown >>> a {
    padding:4px 8px 4
px 8px;

}


.dropdown.show >>> div {
    right:auto;
}

.nowrap{
    display:inline-flex;
    white-space: nowrap;
}

#__BVID__48_{
    width:100px !important;
}

#__BVID__47_{
    width:150px !important;
}

.smaller{
    font-size:11px;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue